// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// Redux:
import { getPageData } from 'actions/page'

class PageHeader extends React.Component {
	constructor( props ) {
		super( props )
	}

	componentDidMount() {

	}

	renderLoading() {
		return (
			<div className="page-header page-header-is-loading">
				<div className="-inner">

				</div>
			</div>
		)
	}

	renderContent() {
		const { page } = this.props
		var subTitle
		var image
		var intro

		document.title = page.title.raw

		const title = (
			<h1 dangerouslySetInnerHTML={ { __html: page.title.rendered } }></h1>
		)

		return (
			<div className="page-header">
				<div className="-inner">
					<div className="-text">
						<div className="-title">
							{ subTitle }
							{ title }
						</div>
					</div>
				</div>
			</div>
		)
	}

	render() {
		return (
			<div>
				{ this.renderContent() }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( PageHeader )



// WEBPACK FOOTER //
// ./views/page/PageHeader.jsx